import React, { lazy } from "react";
import { RouteObject } from "react-router-dom";

const GeminiParent = lazy(() => import("./GeminiParent"));

const GEMINI_ROUTES: RouteObject[] = [
  {
    path: "/private/gemini-dashboard",
    element: React.createElement(GeminiParent),
  },
];

export default GEMINI_ROUTES;
